import { api } from './api';
import {
  ATPCheckRequest,
  BatchATPCheckRequest,
  ATPResult,
  BatchATPResult,
} from '../types/atp.types';

// Uses the shared API client, so requests get the right base URL and login token
class ATPService {
  async checkATP(request: ATPCheckRequest): Promise<ATPResult> {
    const response = await api.post<ATPResult>('/inventory/atp/check', request);
    return response.data;
  }

  async checkBatchATP(request: BatchATPCheckRequest): Promise<BatchATPResult> {
    const response = await api.post<BatchATPResult>('/inventory/atp/batch-check', request);
    return response.data;
  }

  async checkOrderATP(orderItems: Array<{ productId: string; quantity: number }>, requiredDate?: string): Promise<BatchATPResult> {
    const request: BatchATPCheckRequest = {
      items: orderItems.map(item => ({
        productId: item.productId,
        quantity: item.quantity,
        requiredDate,
      })),
    };

    return this.checkBatchATP(request);
  }
}

export const atpService = new ATPService();
